import type { ShapeToolOption } from '@blocksuite/affine-gfx-shape';
import { ShapeType } from '@blocksuite/affine-model';
import {
  DiamondIcon,
  EllipseIcon,
  RoundedRectangleIcon,
  SquareIcon,
  TriangleIcon,
} from '@blocksuite/icons/lit';
import { type TemplateResult, html } from 'lit';

import {
  ScribbledDiamondIcon,
  ScribbledEllipseIcon,
  ScribbledRoundedRectangleIcon,
  ScribbledSquareIcon,
  ScribbledTriangleIcon,
} from './icons';

type Config = {
  name: ShapeToolOption['shapeName'];
  generalIcon: TemplateResult<1>;
  scribbledIcon: TemplateResult<1>;
  tooltip: string;
  disabled: boolean;
};

const PentagonIcon = html`<svg width="20" height="20" viewBox="0 0 20 20" style="fill: none !important; stroke: var(--affine-icon-color, currentColor) !important; stroke-width: 1.8px !important;">
  <polygon points="10 2, 18.5 8, 15 17.5, 5 17.5, 1.5 8" style="fill: none !important; stroke: var(--affine-icon-color, currentColor) !important;" />
</svg>`;

const HexagonIcon = html`<svg width="20" height="20" viewBox="0 0 20 20" style="fill: none !important; stroke: var(--affine-icon-color, currentColor) !important; stroke-width: 1.8px !important;">
  <polygon points="10 2, 18.5 6.3, 18.5 14.7, 10 19, 1.5 14.7, 1.5 6.3" style="fill: none !important; stroke: var(--affine-icon-color, currentColor) !important;" />
</svg>`;

export const ShapeComponentConfig: Config[] = [
  {
    name: ShapeType.Rect,
    generalIcon: SquareIcon(),
    scribbledIcon: ScribbledSquareIcon,
    tooltip: 'Square',
    disabled: false,
  },
  {
    name: ShapeType.Ellipse,
    generalIcon: EllipseIcon(),
    scribbledIcon: ScribbledEllipseIcon,
    tooltip: 'Ellipse',
    disabled: false,
  },
  {
    name: ShapeType.Diamond,
    generalIcon: DiamondIcon(),
    scribbledIcon: ScribbledDiamondIcon,
    tooltip: 'Diamond',
    disabled: false,
  },
  {
    name: ShapeType.Triangle,
    generalIcon: TriangleIcon(),
    scribbledIcon: ScribbledTriangleIcon,
    tooltip: 'Triangle',
    disabled: false,
  },
  {
    name: 'roundedRect',
    generalIcon: RoundedRectangleIcon(),
    scribbledIcon: ScribbledRoundedRectangleIcon,
    tooltip: 'Rounded rectangle',
    disabled: false,
  },
  {
    name: ShapeType.Pentagon,
    generalIcon: PentagonIcon,
    scribbledIcon: PentagonIcon,
    tooltip: 'Pentagon',
    disabled: false,
  },
  {
    name: ShapeType.Hexagon,
    generalIcon: HexagonIcon,
    scribbledIcon: HexagonIcon,
    tooltip: 'Hexagon',
    disabled: false,
  },
];

export const ShapeComponentConfigMap = ShapeComponentConfig.reduce(
  (acc, config) => {
    acc[config.name] = config;
    return acc;
  },
  {} as Record<Config['name'], Config>
);
